import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import LoadingIcon from "mdi-react/LoadingIcon";

import { propertyConstants } from "../../constants";
import PropertyCard from "../../shared/components/property-card/PropertyCard";
import { propertyActions } from "../../redux/actions";

const FreshProperty = (props) => {
  const {
    spinnerActions,
    allFreshProperty,
    getAllFreshProperty,
    filters,
    allAllowedCountries,
    userPropertyTypes,
    allPropertyTypes,
    isAuthenticated,
    getAllFavouritesProperty,
    getPropertyTypesByUser,
  } = props;

  const [properties, setProperties] = useState([]);

  const availablePropertyTypes =
    !isAuthenticated && userPropertyTypes.length === 0
      ? allPropertyTypes
      : userPropertyTypes;

  const [payload, setPayload] = useState({
    ...filters,
    pageSize: 8,
    countryIds:
      filters.countryIds.length > 0
        ? filters.countryIds
        : allAllowedCountries.map((country) => country.id),
    propertyTypeIds:
      filters.propertyTypeIds.length > 0
        ? filters.propertyTypeIds
        : availablePropertyTypes.map((pType) => pType.id),
  });

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  useEffect(() => {
    setPayload({
      ...filters,
      pageSize: 8,
      countryIds: isAuthenticated
        ? filters.countryIds.length > 0
          ? filters.countryIds
          : allAllowedCountries.map((country) => country.id)
        : filters.countryIds,
      propertyTypeIds:
        filters.propertyTypeIds.length > 0
          ? filters.propertyTypeIds
          : availablePropertyTypes.map((pType) => pType.id),
    });
    // eslint-disable-next-line
  }, [
    allAllowedCountries,
    userPropertyTypes,
    allPropertyTypes,
    filters,
    isAuthenticated,
  ]);

  useEffect(() => {
    const canFetchAuthenticated =
      isAuthenticated &&
      allAllowedCountries.length > 0 &&
      userPropertyTypes.length > 0;
    const canFetchGuest =
      !isAuthenticated &&
      (userPropertyTypes.length > 0 || allPropertyTypes.length > 0);

    if (canFetchAuthenticated || canFetchGuest) {
      getAllFreshProperty(payload);
    }
    // eslint-disable-next-line
  }, [payload]);

  useEffect(() => {
    if (allFreshProperty) {
      setProperties(allFreshProperty);
    }
    // eslint-disable-next-line
  }, [allFreshProperty]);

  return (
    <div className="property-list container my-2">
      <div className="d-flex align-items-center gap-2">
        <h2 className="fw-bold fs-1-75">Recently Introduced</h2>
        {spinner(propertyConstants.ALL_FRESH_PROPERTY) > -1 && (
          <div className="spinner-heading">
            <LoadingIcon />
          </div>
        )}
      </div>
      <div className="row mt-4 pt-2">
        {properties.map((property) => (
          <React.Fragment key={property?.id}>
            <PropertyCard
              property={property}
              refetch={(isRemoved) => {
                getAllFreshProperty(payload);
                if (isAuthenticated) {
                  getAllFavouritesProperty({ ...payload, pageSize: 4 });
                  if (isRemoved) {
                    getPropertyTypesByUser({
                      countryIds: payload.countryIds,
                    });
                  }
                }
              }}
            />
          </React.Fragment>
        ))}
        {properties.length === 0 && (
          <div className="text-center fs-5">No Properties Found!</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
  allFreshProperty: state.propertyReducer.allFreshProperty,
  allAllowedCountries: state.homeReducer.allAllowedCountries,
  userPropertyTypes: state.propertyReducer.userPropertyTypes,
  allPropertyTypes: state.propertyReducer.allPropertyTypes,
  isAuthenticated: state.authReducer.isAuthenticated,
});

const mapDispatchToProps = (dispatch) => ({
  getAllFreshProperty: (data) =>
    dispatch(propertyActions.getAllFreshProperty(data)),
  getAllFavouritesProperty: (data) =>
    dispatch(propertyActions.getAllFavouritesProperty(data)),
  getPropertyTypesByUser: (data) =>
    dispatch(propertyActions.getPropertyTypesByUser(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FreshProperty);
